export const GET_GROUPS = {
  INITIATE: 'GET_GROUPS_INITIATE',
  SUCCESS: 'GET_GROUPS_SUCCESS',
  FAILED: 'GET_GROUPS_FAILED',
};

export const GET_GROUP_DETAILS = {
  INITIATE: 'GET_GROUP_DETAILS_INITIATE',
  SUCCESS: 'GET_GROUP_DETAILS_SUCCESS',
  FAILED: 'GET_GROUP_DETAILS_FAILED',
};

export const CREATE_GROUP = {
  INITIATE: 'CREATE_GROUP_INITIATE',
  SUCCESS: 'CREATE_GROUP_SUCCESS',
  FAILED: 'CREATE_GROUP_FAILED',
  CLEAR: 'CREATE_GROUP_CLEAR',
};

export const SET_UPLOAD_MSG = 'SET_UPLOAD_MSG';

export const getAllGroupsInitiate = payload => ({
  type: GET_GROUPS.INITIATE,
  payload,
});

export const getAllGroupsFailed = err => ({
  type: GET_GROUPS.FAILED,
  err,
});

export const getAllGroupsSuccess = groupsData => ({
  type: GET_GROUPS.SUCCESS,
  groupsData,
});

export const createGroupInitiate = payload => ({
  type: CREATE_GROUP.INITIATE,
  payload,
});

export const createGroupFailed = err => ({
  type: CREATE_GROUP.FAILED,
  err,
});

export const createGroupSuccess = payload => ({
  type: CREATE_GROUP.SUCCESS,
  newGroup: payload,
});

export const createGroupClear = () => ({
  type: CREATE_GROUP.CLEAR,
});

export const getGroupDetailsInitiate = payload => ({
  type: GET_GROUP_DETAILS.INITIATE,
  payload,
});

export const getGroupDetailsFailed = err => ({
  type: GET_GROUP_DETAILS.FAILED,
  err,
});

export const getGroupDetailsSuccess = groupData => ({
  type: GET_GROUP_DETAILS.SUCCESS,
  groupData,
});

export const setUploadMsg = payload => ({
  type: SET_UPLOAD_MSG,
  uploadMsg: payload,
});
